class ButtonAnimation {
  constructor() {
    this.drawer = document.querySelector("#cart-drawer");
    this.cartDrawerAnimation;
    this.buttonAnimationType;
    if (!this.drawer) return;
    this.init();
  }

  init() {
    /*
    button_animation_type=checkout_loading-animation
    button_animation_type=checkout_cheering
    button_animation_type=atc_loading-animation
    button_animation_type=atc_cheering
    */

    this.cartDrawerAnimation = this.drawer.getAttribute(
      "button_animation_type"
    );
    if (!this.cartDrawerAnimation) return;

    this.buttonAnimationType = this.cartDrawerAnimation.split("_");

    const [buttonType, buttonAction] = this.buttonAnimationType;

    // Validate button type must be 'checkout' or 'atc'
    const validButtonTypes = ["checkout", "atc"];
    // Validate button action must be 'loading-animation' or 'cheering'
    const validButtonActions = ["loading-animation", "cheering"];

    if (
      validButtonTypes.includes(buttonType) &&
      validButtonActions.includes(buttonAction)
    ) {
      this.setupEventListeners();
    } else {
      console.warn(
        'Invalid button animation configuration. Button type must be "checkout" or "atc" and action must be "loading-animation" or "cheering"'
      );
    }
  }

  setupEventListeners() {
    document.addEventListener("submit", (e) => {
      if (!this.buttonAnimationType) {
        return;
      }

      const form = e.target;
      const action = new URL(form.action).pathname;

      const button = e.submitter;

      const [buttonType, buttonAction] = this.buttonAnimationType;

      if (button) {
        buttonAction === "loading-animation"
          ? this.toggleSpinnerButton(button, true)
          : this.toggleCheeringAnimation(button, buttonType, true);

        document.addEventListener("variant:add", () => {
          buttonAction === "loading-animation"
            ? this.toggleSpinnerButton(button, false)
            : this.toggleCheeringAnimation(button, buttonType, false);
          return;
        });
        document.addEventListener("cart:error", () => {
          buttonAction === "loading-animation"
            ? this.toggleSpinnerButton(button, false)
            : this.toggleCheeringAnimation(button, buttonType, false);
          return;
        });
      }
    });
  }

  createSpinner(button) {
    const buttonBackgroundColorBeforeDisable =
      getComputedStyle(button).backgroundColor;

    button.classList.add("disabled", "loading-button-animation");

    const buttonBackgroundColorAfterDisable = getComputedStyle(button).color;

    const spinner = document.createElement("span");
    spinner.className = "button-spinner";
    spinner.innerHTML = `
      <svg class="loader" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
        <style>
          .loader {
            animation: circle-spin 1s linear infinite;
          }

          @keyframes circle-spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        </style>
      
        <g clip-path="url(#clip0_6725_3116)">
        <path d="M23.5156 11.7578C23.5156 18.2515 18.2515 23.5156 11.7578 23.5156C5.26414 23.5156 0 18.2515 0 11.7578C0 5.26414 5.26414 0 11.7578 0C18.2515 0 23.5156 5.26414 23.5156 11.7578ZM21.162 11.7571C21.162 6.56288 16.9514 2.35291 11.7578 2.35291C6.56422 2.35291 2.35291 6.56355 2.35291 11.7571C2.35291 16.9507 6.56355 21.1614 11.7571 21.1614C16.9507 21.1614 21.1614 16.9507 21.1614 11.7571H21.162Z" fill="${buttonBackgroundColorAfterDisable}"/>
        <path d="M10.5614 21.0903C6.44752 20.5696 3.16272 17.391 2.48077 13.3295C2.37999 12.7315 1.83241 12.3136 1.22839 12.368C1.22033 12.3687 1.21294 12.3694 1.20488 12.3701C0.530315 12.4312 0.048581 13.054 0.160784 13.7219C1.01339 18.7999 5.11989 22.7734 10.2638 23.4244C11.0089 23.5185 11.6532 22.9024 11.5773 22.1552C11.5766 22.1465 11.5753 22.1384 11.5746 22.1297C11.5195 21.5889 11.1003 21.1575 10.5607 21.0897L10.5614 21.0903Z" fill="${buttonBackgroundColorBeforeDisable}"/>
        </g>
        <defs>
        <clipPath id="clip0_6725_3116">
        <rect width="23.5156" height="23.5156" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    `;
    return spinner;
  }

  toggleSpinnerButton(button, show) {
    if (show) {
      const spinner = this.createSpinner(button);
      button.appendChild(spinner);
    } else {
      const spinner = button.querySelector(".button-spinner");
      spinner.remove();
      button.classList.remove("disabled", "loading-button-animation");
    }
  }

  createCheeringAnimation(button, buttonType) {
    // Speichere den originalen Text und Stile
    const originalText = button.textContent.trim();

    // Setze den Cheering-Text basierend auf dem Button-Typ
    const cheeringText =
      buttonType == "checkout"
        ? "Checkout wird vorbereitet <span style='font-size: 11px;'>🎉</span>"
        : "Gute Wahl! <span style='font-size: 11px;'>🎉</span>";

    button.classList.add("cheering");
    button.innerHTML = cheeringText;
    button.dataset.originalText = originalText;
  }

  toggleCheeringAnimation(button, buttonType, show) {
    // Prüfe, ob der Button bereits im Cheering-Zustand ist
    if (show) {
      // Wechsel zum Cheering-Zustand
      this.createCheeringAnimation(button, buttonType);
    } else {
      // Zurück zum Original-Zustand
      button.textContent = button.dataset.originalText;
      button.classList.remove("cheering");
    }
  }
}

// Initialize the button animation
document.addEventListener("DOMContentLoaded", () => {
  window.ButtonAnimation = new ButtonAnimation();
});
